(function () {
  'use strict';

  /* progress bar under horizontal rows */
  document.querySelectorAll('[data-bae-row-track]').forEach((track) => {
    const row = track.closest('.bae-row');
    const thumb = row ? row.querySelector('[data-bae-row-thumb]') : null;
    if (!thumb) return;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      thumb.style.width = Math.max(12, ratio * 100) + '%';
      const pos = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.left = pos * (100 - Math.max(12, ratio * 100)) + '%';
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* lazy-load product recommendations */
  const recs = document.querySelector('[data-bae-recs]');
  if (recs && recs.dataset.url) {
    const load = () => {
      fetch(recs.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-bae-recs]');
          if (fresh && fresh.innerHTML.trim()) {
            recs.innerHTML = fresh.innerHTML;
            const track = recs.querySelector('[data-bae-row-track]');
            const thumb = recs.querySelector('[data-bae-row-thumb]');
            if (track && thumb) {
              const sync = () => {
                const max = track.scrollWidth - track.clientWidth;
                const ratio = track.clientWidth / track.scrollWidth;
                thumb.style.width = Math.max(12, ratio * 100) + '%';
                thumb.style.left = (max > 0 ? track.scrollLeft / max : 0) * (100 - Math.max(12, ratio * 100)) + '%';
              };
              track.addEventListener('scroll', sync, { passive: true });
              sync();
            }
          }
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { load(); io.disconnect(); } });
      }, { rootMargin: '400px 0px' });
      io.observe(recs);
    } else { load(); }
  }
})();
